// eslint-disable-next-line no-unused-vars
import { Animation } from '../types';

// Short - small UI moving small distances
const durationShort = '100ms';

// Short - small to medium UI moving moderate distances
const durationShortSlow = '150ms';

// Standard - small to medium UI moving moderate distances
const durationStandardQuick = '250ms';

// Standard - common timing (if unsure, use this)
const durationStandard = '350ms';

// Long - large items moving great distances
const durationLong = '500ms';

// Long - full screen transitional movement
const durationLongSlow = '750ms';

// Basic Entrance - entrance animations for new UI
const cubicBezierBasicEnter = 'cubic-bezier(0, 0, 0, 1)';

// Basic Exit (SM) - small UI exiting
const cubicBezierBasicExitSmall = 'cubic-bezier(0.7, 0, 1, 0.5)';

// Basic Exit (MD/LG) - medium to large UI exiting
const cubicBezierBasicExitMedium = 'cubic-bezier(0.8, 0, 0.9 ,0.1)';

// Persistent (SM) - small UI (short distance)
const cubicBezierPersistentSmall = 'cubic-bezier(0.4, 0, 0.3, 1)';

// Persistent (MD) - medium to large UI
const cubicBezierPersistentMedium = 'cubic-bezier(0.58, 0, 0.38, 1)';

// Pane Exit - large pane closure
const cubicBezierPaneExit = 'cubic-bezier(0.25, 0, 1, 0.3)';

// Modal - small and medium modals
const cubicBezierModalSmall = 'cubic-bezier(0.70, 0, 1, 0.50)';

// Overspill (SM) - small with bounce
const cubicBezierOverspillSmall = 'cubic-bezier(0, 0, 0, 1.15)';

// Overspill (MD) - medium with bounce
const cubicBezierOverspillMedium = 'cubic-bezier(0, 0, 0, 1.25)';

// Overspill (LG) - large with bounce (larger UI elements)
const cubicBezierOverspillLarge = 'cubic-bezier(0, 0, 0, 1.50)';

export const animation: Animation = {
  duration: {
    short: durationShort,
    shortSlow: durationShortSlow,
    standardQuick: durationStandardQuick,
    standard: durationStandard,
    long: durationLong,
    longSlow: durationLongSlow,
  },
  timingFunction: {
    basicEnter: cubicBezierBasicEnter,
    basicExitSmall: cubicBezierBasicExitSmall,
    basicExitMedium: cubicBezierBasicExitMedium,
    persistentSmall: cubicBezierPersistentSmall,
    persistentMedium: cubicBezierPersistentMedium,
    paneExit: cubicBezierPaneExit,
    modalSmall: cubicBezierModalSmall,
    overspillSmall: cubicBezierOverspillSmall,
    overspillMedium: cubicBezierOverspillMedium,
    overspillLarge: cubicBezierOverspillLarge,
  },
};
